/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

(function($) {
	
	$(document).ready(function(){
      $('body').removeClass('d-none');
      
    });
    
    $('[data-action="scrollto"]').on('click', function(e){
      e.preventDefault();
      var target = $(this).attr('href');
      var yPosition = $(target).offset().top - $('#topnav').outerHeight();
      console.log(yPosition, $(target).offset().top, $('#topnav').height());
      //$("html, body").animate({ scrollTop: $(target).offset().top }, 1000);
      $('html').velocity('scroll', {duration: 350, offset:yPosition});
    });
	
})( jQuery );
